module.exports = __webpack_public_path__ + "static/media/9.28b3cc0c.jpg";